import React from 'react'
import PropTypes from 'prop-types'
import withLayout from '../../../layout/withLayout'
import ContentBox from '../../../layout/component/ContentBox'
import Column from '../../../bootstrap/component/Column'
import LabelInput from '../../../form/component/LabelInput'
import Select from '../../../form/component/Select'
import Row from '../../../bootstrap/component/Row'
import { REASSIGNMENT_VALUE_LIST } from '../../state/reassign/const'
import Checkbox from '../../../form/component/Checkbox'
import BlockUi from 'react-block-ui'

const Reassign = ({ fetching, reassignment, changeReassignment, reassignTreatingPhysician, reassignToPartnerPhysician, isReassignmentTreatingPhysician, isReassignmentPartnerPhysician, partnerPhysicianList, treatingPhysicianList, canProceed }) => {
    const proceed = isReassignmentTreatingPhysician ? reassignTreatingPhysician : reassignToPartnerPhysician

    return (
        <BlockUi tag="div" blocking={fetching}>

            <ContentBox title="Reassign to">
                <Row>
                    <Column size={6}>
                        <LabelInput label="Reassign to">
                            <Select
                                object={reassignment}
                                name="reassignTo"
                                valueList={REASSIGNMENT_VALUE_LIST}
                                addEmpty={true}
                                onChange={changeReassignment}/>
                        </LabelInput>
                    </Column>
                    <Column size={6}/>
                </Row>
                <Row top="M">
                    <Column size={6}>
                        <LabelInput label="Current Treating Physician">
                            <Select
                                object={reassignment}
                                name="currentTreatingPhysicianId"
                                valueList={treatingPhysicianList}
                                renderer={({ firstName, lastName }) => {
                                    return firstName + ' ' + lastName
                                }}
                                addEmpty={true}
                                onChange={changeReassignment}/>
                        </LabelInput>
                    </Column>
                    <Column size={6}>
                        {
                            isReassignmentTreatingPhysician && (
                                <LabelInput label="New Treating Physician">
                                    <Select
                                        object={reassignment}
                                        name="newTreatingPhysicianId"
                                        valueList={treatingPhysicianList}
                                        renderer={({ firstName, lastName }) => {
                                            return firstName + ' ' + lastName
                                        }}
                                        addEmpty={true}
                                        onChange={changeReassignment}/>
                                </LabelInput>
                            )
                        }
                        {
                            isReassignmentPartnerPhysician && (
                                <LabelInput label="Partner Physician">
                                    <Select
                                        object={reassignment}
                                        name="partnerPhysicianId"
                                        valueList={partnerPhysicianList}
                                        renderer={({ displayName }) => {
                                            return displayName
                                        }}
                                        addEmpty={true}
                                        onChange={changeReassignment}/>
                                </LabelInput>
                            )
                        }
                    </Column>
                </Row>
                <Row top="M">
                    <Column size={12}>
                        <Checkbox
                            object={reassignment}
                            name="confirmationLegalRequirementsMet"
                            onChange={changeReassignment}
                        >
                            I confirm, that 1.) the change of physician meets all legal requirements. 2.) I am stored as
                            the person who initiated the physician change.
                        </Checkbox>
                    </Column>
                </Row>
                <Row top="M">
                    <Column size={12}>
                        <button
                            disabled={!canProceed}
                            className="btn btn-danger btn-sm"
                            onClick={proceed}>
                            reassign physician
                        </button>
                    </Column>
                </Row>
            </ContentBox>
        </BlockUi>
    )
}

Reassign.propTypes = {
    reassignment: PropTypes.object.isRequired,
    isReassignmentTreatingPhysician: PropTypes.bool.isRequired,
    isReassignmentPartnerPhysician: PropTypes.bool.isRequired,
    changeReassignment: PropTypes.func.isRequired,
    reassignToPartnerPhysician: PropTypes.func.isRequired,
    reassignTreatingPhysician: PropTypes.func.isRequired,
    partnerPhysicianList: PropTypes.array.isRequired,
    treatingPhysicianList: PropTypes.array.isRequired,
    canProceed: PropTypes.bool.isRequired,
    fetching: PropTypes.bool.isRequired,
}

export default withLayout(Reassign)



// WEBPACK FOOTER //
// ./src/modules/treatment/component/reassign/Reassign.js